import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import * as StorageManager from "../../../../src/utils/StorageManager";
import constants from "../../../../src/constants";
import * as authSelectors from "../../../../src/selectors/auth";
import * as generalSelectors from "../../../selectors/general";
import CashWithdrawalDetail from "../../../views/EWithdraw/components/CashWithdrawalDetail";
import CashWithdrawalNotes from "../../../views/EWithdraw/components/CashWithdrawalNotes";
import * as paymentSelectors from "../../../selectors/payment";
import * as eWithdrawSelectors from "../../../selectors/e-withdraw";

function CashWithdrawal({ generalData }) {
    const [page, setPage] = useState(1);
    const [viewData, setViewData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [token, setToken] = useState(null);
    const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
    const withdrawStatusOptions = generalSelectors.getGeneralOptionsContractStatus(generalData);
    const history = useHistory();

    // const data = useSelector((state) => paymentSelectors.getPaymentItems(state));
    // const currency = useSelector((state) => paymentSelectors.getPaymentCurrency(state));
    // const bankName = useSelector((state) => eWithdrawSelectors.getAttributeBankName(state));
    const withdrawData = useSelector((state) => eWithdrawSelectors.getWithdrawData(state));
    const clientCode = useSelector((state) => eWithdrawSelectors.getWithdrawClientCode(state));
    const bankAccount = useSelector((state) => eWithdrawSelectors.getWithdrawBankAccount(state));
    const totalAmount = useSelector((state) => eWithdrawSelectors.getWithdrawTotalAmount(state));

    useEffect(() => {
        setTokenFunction();
    }, [isLogout]);

    async function setTokenFunction() {
        setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
    }

    // const { loading, data, isFetched } = useQuery({
    //     queryKey: ["withdraw-data"],
    //     queryFn: async () => {
    //         try {
    //             return await axiosInstance.get(`/clientarea/withdraw${search}`);
    //         } catch (e) {
    //             Helper.handleHttpError(e, dispatch, history);
    //         }
    //     },
    //     retryDelay: 15000,
    //     enabled: !_.isEmpty(token),
    // });


    const onClickViewPayment = (item) => {
        setViewData(item);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setViewData(null);
    };

    return (
        <div className="container-fluid">
        {/*<div className="mt-4 pb-4">*/}
            <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
                <div className={clsx("custom-card-label-container text-center")}>
                    <h2>Cash Withdrawal</h2>
                </div>
                <div className="transaction-history-container">
                    <CashWithdrawalDetail
                                           page={page}
                                           setPage={setPage}
                                           onClickViewPayment={onClickViewPayment}
                                           viewData={viewData}
                                           showModal={showModal}
                                           handleCloseModal={handleCloseModal}
                                           withdrawData={withdrawData}
                                           clientCode={clientCode}
                                           bankAccount={bankAccount}
                                           totalAmount={totalAmount}
                    />
                </div>
            </div>
            <CashWithdrawalNotes></CashWithdrawalNotes>
        </div>
        // </div>
    );
}
export default CashWithdrawal;
